import styled from "styled-components";

const Text = styled.p`
  font-size: 25px;
  line-height: 30px;
  font-weight: 600;
`;

export { Text };
